import { ContactAnimation } from "../component/Transitions";

export default function Client() {
  return (
    <div class="about" style={{textAlign: "center",marginTop: "20%"}}>
      <ContactAnimation>
        <h1>Test Contact</h1>
        <p>Contact para</p>
      </ContactAnimation>
    </div>
  )
}